import React from "react";

export default function See() {
  return (
    <svg
      width="11"
      height="6"
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.34096 0.257812C2.98839 0.257812 0.927246 3.21075 0.927246 3.21075C0.927246 3.21075 2.98839 6.16368 6.34096 6.16368C9.69352 6.16368 11.7547 3.21075 11.7547 3.21075C11.7547 3.21075 9.69352 0.257812 6.34096 0.257812ZM6.34096 5.17937C4.40039 5.17937 2.93229 3.95686 2.21719 3.21075C2.72903 2.67676 3.62574 1.90309 4.80297 1.50346C4.52574 1.84792 4.37388 2.27642 4.37234 2.71859C4.37234 3.2407 4.57974 3.74143 4.94893 4.11062C5.31812 4.47981 5.81885 4.68721 6.34096 4.68721C6.86307 4.68721 7.3638 4.47981 7.73299 4.11062C8.10217 3.74143 8.30958 3.2407 8.30958 2.71859C8.30804 2.27642 8.15618 1.84792 7.87895 1.50346C9.05667 1.90309 9.95387 2.67725 10.4647 3.21075C9.74864 3.95784 8.28104 5.17937 6.34096 5.17937Z"
        fill="#474747"
      />
    </svg>
  );
}
